
import EpisodeCard from './episode';
import ReactAudioPlayer from 'react-audio-player';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Parser from 'rss-parser';
import { Row, Col } from 'react-bootstrap';

import logo from '../assets/logo.jpeg';

class Feed extends Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            currentTrack: "",
            autoplay: false,
            stickyPlayer:false,

        }
        this.setTrack = this.setTrack.bind(this);
        this.episodeFeedRef = React.createRef();

    }

    componentDidMount() {
        this.loadRssFeed().then(
            (items) => {
                let currentTrack = ""
                if (items.length > 0) {
                    currentTrack = items[0]
                }
                this.setState({
                    items: items,
                });
                this.setTrack(currentTrack.guid);
            }
        )


        window.addEventListener('scroll', (e) => {
            let boundingBox = this.episodeFeedRef.current.getBoundingClientRect(); //outputs <h3> coordinates
            if(this.state.stickyPlayer && boundingBox.y > 0){
                this.setState({stickyPlayer:false});
            }else if(!this.state.stickyPlayer && boundingBox.y < 0){
                this.setState({stickyPlayer:true});
            }
        });

    }

    loadRssFeed() {
        return new Promise((resolve, reject) => {
            let parser = new Parser();
            parser.parseURL('/feed.xml?' + Date.now(), (err, feed) => {
                resolve(feed.items);
            });
        })
    }

    setTrack(url, autoplay = false) {
        if(this.state.currentTrack !== ""){
            setTimeout(()=>{
                let audioPlayer = document.getElementsByTagName("AUDIO")[0];
                audioPlayer.play();
        
            }, 500)
        }
        this.setState({
            currentTrack: url,
            autoplay: autoplay
        })     
       
    }

    render() {
        let episodes = []
        let i = 0;
        this.state.items.forEach((item) => {
            episodes.push(<EpisodeCard
                title={item.title}
                date={item.pubDate}
                description={item.content}
                url={item.guid}
                playing={this.state.currentTrack === item.guid}
                setTrack={this.setTrack}
                key={++i}
            />)
        });

        let playerContainerClassname = ( "sticky" )
        return (
            <div ref={this.episodeFeedRef}>
                <div className = {playerContainerClassname}>
                    <ReactAudioPlayer src={this.state.currentTrack} autoplay={this.state.autoplay} controls={true} />
                </div>                
                <ul className="episode-feed">
                    {episodes}
                </ul>
            </div>
        )

    }
}
export default Feed; 